export default "/images/framework/Movie.a8e7dbff.svg?a8e7dbff";